<template>
  <div :key="componentKey" :class="sidebarClasses"
       :data-background-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo" style="text-align: center;">
      <div style="color: white; font-size: large; padding-left: 10px; padding-right: 10px;">
        TEAMTIP
      </div>
      <!--
      <el-select style="width: 90%;" class="select-danger"
                 @change="betgameSelected"
                 placeholder="Single Select"
                 v-model="selects.simple">
        <el-option v-for="option in authoredBetgames"
                   class="select-danger"
                   :value="option.value"
                   :label="option.label"
                   :key="option.id">
        </el-option>
      </el-select>
      -->
      <!--
      <a class="simple-text logo-normal" style="text-align: center" target="_blank" href="http://www.sportplatz-media.com/">
          {{ title }}
      </a>
      -->
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul :class="navClasses">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    data: function () {
      return {
        selects: {
          simple: this.$store.state.betgame,
          countries: [],
          multiple: 'ARS'
        },
        componentKey: 0
      }
    },
    created () {

    },
    mounted () {
      this.initScrollBarAsync()
    },
    props: {
      title: {
        type: String,
        default: 'Tippspiel'
      },
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: 'static/img/vue-logo.png'
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      }
    },
    methods: {
      async initScrollBarAsync () {
        await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
        const PerfectScroll = await import('perfect-scrollbar')
        if (this.$refs.sidebarScrollArea) {
          PerfectScroll.initialize(this.$refs.sidebarScrollArea)
        }
      }
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  .select-danger > div {
    font-size: smaller;
  }
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue